import { render } from "./DatasetStats.vue?vue&type=template&id=1e857904&scoped=true"
import script from "./DatasetStats.vue?vue&type=script&lang=js"
export * from "./DatasetStats.vue?vue&type=script&lang=js"

import "./DatasetStats.vue?vue&type=style&index=0&id=1e857904&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e857904"]])

export default __exports__